import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
